import { defineVariants } from "@/runtime/style-engine/define-variants";

/**
 * Chip-specific layout/size overrides on top of cardClasses.
 * Card supplies color/variant chrome via --card-color; chip gives it pill shape and tight sizing.
 */
export const chipClasses = defineVariants({
  base: `
    inline-flex! flex-row! w-auto!
    items-center justify-center gap-1!
    font-medium leading-none
    select-none whitespace-nowrap
    py-0!
  `,

  variants: {
    size: {
      xs: `text-[10px] h-4! px-1.5! rounded!`,
      sm: `text-xs h-5! px-2! rounded-md!`,
      md: `text-xs h-6! px-2.5! rounded-lg!`,
      lg: `text-sm h-7! px-3! rounded-lg!`,
      xl: `text-sm h-8! px-3.5! rounded-lg!`,
    },

    square: {
      true: `aspect-square px-0!`,
      false: ``,
    },
  },

  defaults: {
    size: "md",
    square: "false",
  },
});
